module.exports = __webpack_public_path__ + "/bundle/asset/admission5-73c6d25c2ee0f3d06cce33a3b1946c4a.png";